import React from 'react';
import { Alert, AlertTitle, Typography, Box } from '@mui/material';

interface ValidationErrorDisplayProps {
  error: {
    message: string;
    code?: string;
    details?: {
      entityType?: string;
      entityName?: string;
      entityId?: number;
      reason?: string;
      cyclePath?: string[];
    };
  };
  onClose?: () => void;
}

export const ValidationErrorDisplay: React.FC<ValidationErrorDisplayProps> = ({ error, onClose }) => {
  return (
    <Alert severity="error" onClose={onClose}>
      <AlertTitle>Validation Error</AlertTitle>
      <Typography variant="body1">{error.message}</Typography>
      
      {error.details && (
        <Box sx={{ mt: 1 }}>
          {error.details.entityName && (
            <Typography variant="body2">
              <strong>Entity:</strong> {error.details.entityType} "{error.details.entityName}"
            </Typography>
          )}
          
          {error.details.reason && (
            <Typography variant="body2">
              <strong>Reason:</strong> {error.details.reason}
            </Typography>
          )}
          
          {error.details.cyclePath && error.details.cyclePath.length > 0 && (
            <Box sx={{ mt: 1 }}>
              <Typography variant="body2">
                <strong>Circular Dependency Path:</strong>
              </Typography>
              <Typography variant="body2">
                {error.details.cyclePath.join(' → ')}
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </Alert>
  );
};
